import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';

import { setMappingFile, loadImportFiles } from './store/actions/importer';
import { getTotalErrors } from './store/run_records_selectors';
import { getMappingRequiredFields } from './store/actions/mapping';
import { getCurrentFile, getImportFiles } from './store/selectors';

import './files-list.scss';

export function FilesList({
  currentFile,
  files,
  getMappingRequiredFields,
  loadImportFiles,
  setMappingFile,
  totalErrors
}) {

  useEffect(() => {
    if (!files.length) return;
    setMappingFile(files[0]);
  }, [files]);

  useEffect(() => {
    if (!currentFile) return;
    getMappingRequiredFields(currentFile.id);
  }, [currentFile]);

  useEffect(() => {
    loadImportFiles();
  }, []);

  const renderFile = (file) => {
    const className = currentFile.id == file.id ? 'active' : '';
    const isDangerColorRequired = currentFile.id != file.id && totalErrors > 0;
    const hasDangerRecords = currentFile.id == file.id && totalErrors > 0;

    return (
      <li className={className} key={file.id}>
        <a className="clickable" onClick={() => setMappingFile(file)}>
          <span className={isDangerColorRequired ? 'danger-icon' : ''}>
            {hasDangerRecords && <FontAwesomeIcon icon={faExclamationTriangle} />}
          </span>
          <span className="hidden-xs left-buffer-sm text-capitalize">{file.name}</span>
        </a>
      </li>
    );
  };

  return (
    <React.Fragment>
      <div className="mb-4">
        <h3 className="semi-bold mb-4">Files</h3>
        <p className="mt-4">
          Select the file you would like to review.
        </p>
      </div>
      <ul className="nav nav-pills nav-stacked">
        {files.map(renderFile)}
      </ul>
    </React.Fragment>
  );
}

FilesList.propTypes = {
  currentFile: PropTypes.object.isRequired,
  files: PropTypes.array.isRequired,
  getMappingRequiredFields: PropTypes.func.isRequired,
  loadImportFiles: PropTypes.func.isRequired,
  setMappingFile: PropTypes.func.isRequired,
  totalErrors: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  currentFile: getCurrentFile(state),
  files: getImportFiles(state),
  totalErrors: getTotalErrors(state)
});

const mapDispatchToProps = {
  getMappingRequiredFields,
  setMappingFile,
  loadImportFiles
};

export default connect(mapStateToProps, mapDispatchToProps)(FilesList);
